/**
 * @name: financialManagement.js
 * @description: 财务管理路由
 * @author: 于海威
 * @create: 2020/08/07 17:15:51
 * @update: 2020/08/07 17:15:51
 */

export default [
  {
    path: '/finance/bill/publicBillList',
    name: 'publicBillList',
    component: () => import('@/views/finance/bill/publicBillList.vue'),
    meta: {
      title: '对公对账单'
    }
  },
  {
    path: '/finance/bill/publicBillDetail',
    name: 'publicBillDetail',
    component: () => import('@/views/finance/bill/publicBillDetail.vue'),
    meta: {
      title: '对公对账单明细',
      parentRoutePath: 'publicBillList'
    }
  },
  {
    path: '/finance/bill/personalBillList',
    name: 'personalBillList',
    component: () => import('@/views/finance/bill/personalBillList.vue'),
    meta: {
      title: '对私对账单',

    }
  },
  {
    path: '/finance/bill/personalBillDetail',
    name: 'personalBillDetail',
    component: () => import('@/views/finance/bill/personalBillDetail.vue'),
    meta: {
      title: '对私对账单明细',
      parentRoutePath: 'personalBillList'
    }
  },
  {
    path: '/finance/profit/profitBaseList',
    name: 'profitBaseList',
    component: () => import('@/views/finance/profit/profitBaseList.vue'),
    meta: {
      title: '订单收益基础数据',

    }
  },
  {
    path: '/finance/profit/profitList',
    name: 'profitList',
    component: () => import('@/views/finance/profit/profitList.vue'),
    meta: {
      title: '收益流水',

    }
  },
  {
    path: '/finance/profit/profitDetail',
    name: 'profitDetail',
    component: () => import('@/views/finance/profit/profitDetail.vue'),
    meta: {
      title: '收益详情',
      parentRoutePath: 'profitList'
    }
  },
  {
    path: '/finance/cash/extractCash',
    name: 'extractCash',
    component: () => import('@/views/finance/cash/extractCash.vue'),
    meta: {
      title: '提现明细'
    }
  },
  {
    path: '/finance/cash/accountAuditList',
    name: 'accountAuditList',
    component: () => import('@/views/finance/cash/accountAuditList.vue'),
    meta: {
      title: '账户审核'
    }
  },
  {
    path: '/finance/cash/auditDetail',
    name: 'auditDetail',
    component: () => import('@/views/finance/cash/auditDetail.vue'),
    meta: {
      title: '平台审核',
      parentRoutePath: 'accountAuditList'
    }
  },
  {
    path: '/finance/income/list',
    name: 'incomeManagement',
    component: () => import('@/views/finance/income/List.vue'),
    meta: {
      title: '收支明细'
    }
  },
  {
    path: '/finance/surplusImport/list',
    name: 'surplusImportManagement',
    component: () => import('@/views/finance/surplusImport/List.vue'),
    meta: {
      title: '余额变动申请导入'
    }
  },
  {
    path: '/finance/surplusImport/detail',
    name: 'surplusImportDetailManagement',
    component: () => import('@/views/finance/surplusImport/Detail.vue'),
    meta: {
      title: '余额变动申请导入详情',
      parentRoutePath: 'surplusImportManagement'
    }
  },
  {
    path: '/finance/surplusApply/list',
    name: 'surplusApplyManagement',
    component: () => import('@/views/finance/surplusApply/List.vue'),
    meta: {
      title: '余额变动申请列表'
    }
  },
  {
    path: '/finance/surplusApply/detail',
    name: 'surplusApplyDetailManagement',
    component: () => import('@/views/finance/surplusApply/Detail.vue'),
    meta: {
      title: '余额变动申请详情',
      parentRoutePath: 'surplusApplyManagement'
    }
  },
];
